import React from "react";
import "./Agents.css";

export default function AgentsTabs({ activeTab = 'closure', setActiveTab }) {

  return (
    <div className="business_seg_tabs">
    <div className="navbar navbar-expand-lg container-fluid custom_subnavbar" >
      <ul className="nav nav-tabs custom_nav_tab" >
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 'closure' ? 'active' : ''}`}
              onClick={() => setActiveTab('closure')}
            >
              Closure
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 'champion' ? 'active' : ''}`}
              onClick={() => setActiveTab('champion')}
            >
              Champion
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 'delivery_excellence' ? 'active' : ''}`}
              onClick={() => setActiveTab('delivery_excellence')}
            >
              Delivery Excellence
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 'renewal' ? 'active' : ''}`}
              onClick={() => setActiveTab('renewal')}
            >
              Renewal
            </a>
          </li>
      </ul>
    </div>
  </div>
  );
}
